import { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, Download, Trash2, Search, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/newsletter', { params: q ? { q } : {} });
      setItems(r.data?.items || []);
      setTotal(r.data?.total || 0);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);

  const remove = async (sub) => {
    if (!window.confirm(`Rimuovere ${sub.email}?`)) return;
    await api.delete(`/admin/newsletter/${sub.id}`);
    toast.success('Rimosso'); load();
  };

  const downloadCsv = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/newsletter/export.csv`;
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('fail');
      const blob = await res.blob();
      const dl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = dl; a.download = 'newsletter.csv'; a.click();
      window.URL.revokeObjectURL(dl);
      toast.success('CSV scaricato');
    } catch (err) { toast.error('Errore download'); }
  };

  return (
    <AdminLayout title="Iscritti Newsletter">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div className="flex items-center gap-2 text-sm text-[color:var(--text-muted)]">
          <Mail className="w-4 h-4 text-[color:var(--gold)]"/>
          <span><b className="text-[color:var(--gold)]">{total}</b> iscritti attivi</span>
        </div>
        <div className="flex gap-2">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-subtle)]"/>
            <Input data-testid="newsletter-search" placeholder="Cerca email…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 bg-[color:var(--surface)] border-[color:var(--border-c)] w-[260px]"/>
          </div>
          <Button data-testid="newsletter-export" onClick={downloadCsv} className="bg-[color:var(--gold-strong)] hover:bg-[#C6A21A] text-black"><Download className="w-4 h-4 mr-2"/>Esporta CSV</Button>
        </div>
      </div>

      <div className="rounded-xl border border-[color:var(--border-c)] bg-[color:var(--surface)] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wider text-[color:var(--text-subtle)] bg-[color:var(--bg-2)]"><tr><th className="p-3">Email</th><th className="p-3">Fonte</th><th className="p-3">Iscritto il</th><th className="p-3 text-right">Azioni</th></tr></thead>
          <tbody className="divide-y divide-[color:var(--border-c)]">
            {loading ? (<tr><td colSpan="4" className="p-6 text-center text-[color:var(--text-muted)]">Caricamento…</td></tr>) : items.length === 0 ? (<tr><td colSpan="4" className="p-10 text-center text-[color:var(--text-muted)]"><Send className="w-8 h-8 mx-auto opacity-50 mb-2"/>Nessun iscritto</td></tr>) : items.map((s) => (
              <tr key={s.id} className="hover:bg-[rgba(214,185,140,0.04)]" data-testid="newsletter-row">
                <td className="p-3 font-medium">{s.email}</td>
                <td className="p-3 text-[color:var(--text-muted)]">{s.source || 'footer'}</td>
                <td className="p-3 text-[color:var(--text-muted)]">{(s.subscribed_at || '').slice(0,16).replace('T', ' ')}</td>
                <td className="p-3 text-right"><Button size="sm" variant="ghost" onClick={() => remove(s)} className="text-red-400 hover:text-red-300" data-testid="newsletter-delete"><Trash2 className="w-4 h-4"/></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
